import {app} from '../../app';
import {ISessionService} from "../../services/SessionService";

export class SelectQuestionPreviewComponent {

    protected sessionService:ISessionService;

    public question:IQuestion;
    public value:string;

    choices:string[] = [];

    static $inject = ['SessionService'];

    constructor(sessionService:ISessionService) {
        this.sessionService = sessionService;
    }

    $onInit() {
        const choices = this.question.meta.choices;
        if (choices) {
            this.choices = choices;
        }

        if (this.question.meta.emptyValue) {
            this.choices.unshift("");
            this.value = "";
        }

        const defaultValue = this.question.meta.default;
        if (defaultValue && this.choices.indexOf(defaultValue) > -1) {
            this.value = defaultValue;
        }

        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0 && answer.values[0]) {
            this.value = answer.values[0].value;
        }
    }

}

app.component('selectQuestionPreview', {
    templateUrl: 'templates/components/questionPreviews/selectQuestionPreview.html',
    controller: SelectQuestionPreviewComponent,
    controllerAs: 'selectQuestionPreview',
    bindings: {
        question: '<',
    }
});